import {
  toWSDateString,
  WSButton,
  WSCard,
  WSContainer,
  WSEmptyState,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { getCurrentTaxPaymentQuarter } from "@wingspanhq/utils/dist/date/taxDeadlines";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useHistory } from "react-router-dom";
import { usePendingWithholding } from "../../../../query/taxes/queries";
import { WSQueries } from "../../../../query/WSQuery";
import { RoutePropsFromRouteHelpers } from "../../../../shared/utils/createRouteHelpers";
import {
  PATH_TAXES,
  routeHelpersTaxesSchedulePaymentConfirmation
} from "../../paths";
import { Layout } from "../../../../shared/components/Layout";

const quarterInfo = getCurrentTaxPaymentQuarter();

export const ConfirmationSchedulePayment: React.FC<
  RoutePropsFromRouteHelpers<
    typeof routeHelpersTaxesSchedulePaymentConfirmation
  >
> = ({ match }) => {
  const {
    params: { pendingWithholdingId }
  } = routeHelpersTaxesSchedulePaymentConfirmation.useData();

  const history = useHistory();

  const queryPendingWithholding = usePendingWithholding(pendingWithholdingId);

  return (
    <Layout
      onClose={() => history.push(PATH_TAXES)}
      title={`Schedule payment to IRS - ${quarterInfo.quarter} ${quarterInfo.year}`}
      onBack={() => history.goBack()}
      wide
    >
      <WSQueries queries={{ queryPendingWithholding }}>
        {({ queryPendingWithholdingData }) => (
          <WSContainer verticalPadding>
            <WSCard mt="XL">
              <WSList gap="XL">
                <WSEmptyState
                  type="done"
                  orientation="horizontal"
                  hasBorder={false}
                  title="Your payment has been scheduled"
                  description={`The amount scheduled, ${formatMoney(
                    queryPendingWithholdingData.amount,
                    "USD"
                  )}, will be set aside from the available balance in the account to ensure your scheduled payment is sent in full to the IRS.`}
                />

                <WSInfoBox>
                  <WSText.ParagraphSm color="gray500">
                    No changes can be made after the processing deadline on{" "}
                    <b>{toWSDateString(quarterInfo.internalDeadline)} EST</b>.
                  </WSText.ParagraphSm>
                </WSInfoBox>
              </WSList>
            </WSCard>

            <WSButton
              kind="Primary"
              fullWidth
              mt="2XL"
              onClick={() => history.push(PATH_TAXES)}
            >
              Back to Tax Withholdings
            </WSButton>
          </WSContainer>
        )}
      </WSQueries>
    </Layout>
  );
};
